import { db, auth, storage, adminAuth } from './config'
import { collection, doc } from 'firebase/firestore'

export const siteRef = (id: string) => doc(db, 'sites', id)
export const sitesCollectionRef = collection(db, 'sites')
export const eventsCollectionRef = (siteId: string) => {
  return collection(db, `sites/${siteId}/events`)
}
export const eventRef = (siteId: string, eventId: string) => {
  return doc(db, `sites/${siteId}/events/${eventId}`)
}

export const userRef = (id: string) => doc(db, 'users', id)
export const usersCollectionRef = collection(db, 'users')

export { db, auth, adminAuth, storage }
